"use client";

import { Core } from "@faire/design-tokens";
// eslint-disable-next-line @faire-localization/no-restricted-imports
import { strictLocalize } from "@faire/web/common/localization";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1687))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:45:00.056Z
 */
export const TrashCan = createSVGIcon(
  <>
    <path
      d="M1.71436 6H22.2858"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.28613 6H19.7147V21.4286C19.7147 21.8832 19.5341 22.3193 19.2126 22.6408C18.8911 22.9622 18.4551 23.1429 18.0004 23.1429H6.00042C5.54576 23.1429 5.10973 22.9622 4.78824 22.6408C4.46674 22.3193 4.28613 21.8832 4.28613 21.4286V6Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.71436 6.00003V5.14289C7.71436 4.00625 8.16588 2.91616 8.96961 2.11243C9.77334 1.30871 10.8634 0.857178 12.0001 0.857178C13.1367 0.857178 14.2268 1.30871 15.0305 2.11243C15.8343 2.91616 16.2858 4.00625 16.2858 5.14289V6.00003"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.42871 9.42871V18.8573"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5713 9.42871V18.8573"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "TrashCan",
  {
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      defaultMessage: "Remove",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
    color: Core.icon.default,
  }
);
